import styled, { css } from 'styled-components'
import { media } from '../../style/constants'

export const Wrapper = styled.div`
  display: none;
  height: 15px;
  width: 1.75rem;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  backface-visibility: hidden;
  transition: transform .45s cubic-bezier(.45, 0, .07, 1);
  will-change: transform;

  span {
    display: inline-block;
    height: 1px;
    background: #fff;
  }
  
  ${media.md`
    display: flex;
  `}
`



// WEBPACK FOOTER //
// ./src/components/ToggleMenu/style.js